import type { ActivityContentProjectCheckInAcknowledged } from "@/api";
import type { Activity } from "@/models/activities";
import type { ActivityHandler } from "../interfaces";

import { feedTitle, projectCheckInLink, projectLink } from "./../feedItemLinks";

const ProjectCheckInAcknowledged: ActivityHandler = {
  pageHtmlTitle(_activity: Activity) {
    throw new Error("Not implemented");
  },

  pagePath(paths, activity: Activity): string {
    const { checkIn, project } = content(activity);

    if (checkIn?.id) {
      return paths.projectCheckInPath(checkIn.id);
    } else {
      return paths.projectPath(project!.id);
    }
  },

  PageTitle(_props: { activity: any }) {
    throw new Error("Not implemented");
  },

  PageContent(_props: { activity: Activity }) {
    throw new Error("Not implemented");
  },

  PageOptions(_props: { activity: Activity }) {
    return null;
  },

  FeedItemTitle({ activity, page }: { activity: Activity; page: any }) {
    const project = content(activity).project!;
    const checkInLink = projectCheckInLink(content(activity).checkIn);

    if (page === "project") {
      return feedTitle(activity, "acknowledged a", checkInLink);
    } else {
      return feedTitle(activity, "acknowledged a", checkInLink, " in the", projectLink(project), "project");
    }
  },

  FeedItemContent(_props: { activity: Activity; page: any }) {
    return null;
  },

  feedItemAlignment(_activity: Activity): "items-start" | "items-center" {
    return "items-center";
  },

  commentCount(_activity: Activity): number {
    throw new Error("Not implemented");
  },

  hasComments(_activity: Activity): boolean {
    throw new Error("Not implemented");
  },

  NotificationTitle(_props: { activity: Activity }) {
    return "Acknowledged check-in";
  },

  NotificationLocation({ activity }: { activity: Activity }) {
    return content(activity).project!.name!;
  },
};

function content(activity: Activity): ActivityContentProjectCheckInAcknowledged {
  return activity.content as ActivityContentProjectCheckInAcknowledged;
}

export default ProjectCheckInAcknowledged;
